export const API_GET: string = 'DOGLEY/API_GET'
export const API_POST: string = 'DOGLEY/API_POST'
